import { ComponentSlotStyle, Text } from "@fluentui/react-northstar";
import React, { Component } from "react";

export interface KeepMountedProps {
    isMounted: boolean;
    render: () => JSX.Element;
}

export class KeepMounted extends Component<KeepMountedProps> {
    children: JSX.Element | null = null;
    render() {
        const { isMounted, render } = this.props;
        if (this.props.isMounted) {
            this.children = this.children ? this.children : render();
        }
        return <div style={{ display: isMounted ? undefined : "none" }}>{this.children}</div>;
    }
}
